var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var EntityModel = require('../../models/entity-model');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');


var ReviewerSelectView = Marionette.View.extend({
    template: require('../../templates/review/reviewers-items-select.html'),

    regions: {
        reviewersSelect: '#reviewers-select'
    },

    events: {
        'click .save': 'saveReviewer',
        'click .cancel': 'cancel'
    },

    childViewEvents: {
        'suggestor:selected:md': 'onMdSelected',
        'suggestor:selected:organization': 'onOrganizationSelected',
    },

    constants: {
        maxNumberOfItemsInControlWithSuggester: 20
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'saveReviewer', 'cancel', 'showReviewerSelect', 'onMdSelected', 'onOrganizationSelected', 'renderReviewerSelect');
        this.reviewer = options.reviewer;
        this.isReviewerPerson = options.isReviewerPerson;
        this.placeholder = options.isReviewerPerson ? 'Select a person' : 'Select an org.';
        this.documentId = options.documentId;
        this.onSave = options.onSave;
        this.onCancel = options.onCancel;

    },
    utils: new CommonUtils(),

    templateContext: function () {
        var that = this;
        return {}
    },

    onRender: function () {

        if (this.isReviewerPerson) {
            this.renderReviewerSelect(this.reviewer.personId, true);
        } else {
            this.renderReviewerSelect(this.reviewer.organizationId, false);
        }
    },

    renderReviewerSelect: function(reviewerId, isReviewerPerson) {
        var that = this;
        if (!reviewerId) {
            that.showReviewerSelect(isReviewerPerson);
            return;
        }

        var current = new EntityModel({
            id: reviewerId
        });
        current.fetch({
            success: function () {
                that.showReviewerSelect(isReviewerPerson, {
                    id: current.get('id'),
                    name: current.get('name')
                });
            },
            error: function () {
                that.showReviewerSelect(isReviewerPerson);
            }
        });
    },

    showReviewerSelect: function (isReviewerPerson, defaultSelected) {
        var that = this;

        that.showChildView('reviewersSelect', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=' + (isReviewerPerson ? 'person' : 'organization'),
            symbolForSearchInUrl: '~~~',
            listLocation: (isReviewerPerson ? function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isMd;
                });
            } : function (data) {
                return data.filter(function (item) {
                    return item.object;
                });
            }),
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: that.placeholder,
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: isReviewerPerson  ? 'md': 'organization',
            defaultSelected: defaultSelected
        }));
    },

    onMdSelected: function (id) {
        this.reviewer.personId = id;
    },

    onOrganizationSelected: function (id) {
        this.reviewer.organizationId = id;
    },

    saveReviewer: function () {
        var that = this;

        if (!this.reviewer.organizationId && !this.reviewer.personId) {
            notificationsChannel.request('show:notification', 'The organization or MD must be filled');
            return;
        }

        this.reviewer = _.omit(this.reviewer, 'statusText');
        that.utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/document/' + this.documentId + '/reviewer',
            data: JSON.stringify(this.reviewer),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    // notificationsChannel.request('show:notification', {message:"saved", code:200}); //maybe this needed but i think when we implement hide possibility off success notifications in user profile
                    that.onSave(response);
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    cancel: function() {
        this.onCancel();
    }
});

module.exports = ReviewerSelectView;


//////////////////
// WEBPACK FOOTER
// ./app/views/review/reviewers-items-select.js
// module id = 405
// module chunks = 0